<script setup>
// TODO: migration to DVC scheduled for march 2024
const { t } = useI18n()

const dataBus = inject('dataBus', {})
const dataQuery = inject('dataQuery', {})

const length = computed(() => {
  return dataQuery.value?.paging?.count
})

const start = computed(() => {
  return (currentPage.value - 1) * perPage.value
})

const end = computed(() => {
  return start.value < length.value
    ? Math.min(start.value + perPage.value, length.value)
    : start.value + perPage.value
})

const totalPages = computed(() => {
  return dataQuery.value?.paging?.totalPages
})

const currentPage = computed(() => {
  return dataQuery.value?.paging?.currentPage
})

const perPage = computed(() => {
  return dataQuery.value?.paging?.perPage
})
</script>

<template>
  <p class="text-sm color-text-400">
    <i18n-t keypath="Showing { start } to { end } of { length }">
      <template #start>
        <span class="font-bold">{{ length > 0 ? start + 1 : 0 }}</span>
      </template>
      <template #end>
        <span class="font-bold">{{ length > 0 ? end : 0 }}</span>
      </template>
      <template #length>
        <span class="font-bold">{{ length }}</span>
      </template>
    </i18n-t>
  </p>
</template>

<i18n>
{
  "en-us": {
    "Showing { start } to { end } of { length }": "Showing { start } to { end } of { length }"
  },
  "de": {
    "Showing { start } to { end } of { length }": "Anzeige von { start } bis { end } von { length }"
  },
  "es": {
    "Showing { start } to { end } of { length }": "Mostrando de { start } a { end } sobre { length }"
  },
  "fr": {
    "Showing { start } to { end } of { length }": "Affichage de { start } à { end } sur { length }"
  }
}
</i18n>
